import React, { useState, useEffect, useRef } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { FaArrowLeftLong } from "react-icons/fa6";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "../../axiosInstance";
import { useFormik } from "formik";
import { object, string, number, setLocale } from "yup";
import { toast } from "react-toastify";
import Modal from "react-bootstrap/Modal";
import { IoIosInformationCircleOutline } from "react-icons/io";
import { GoSearch } from "react-icons/go";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";

const wholesaler_columns = [
  {
    field: "wholesaler_id",
    headerName: "WHOLESALER ID",
    flex: 0.8,
    minWidth: 140,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "business_name",
    headerName: "BUSINESS NAME",
    flex: 1.3,
    minWidth: 200,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "email",
    headerName: "EMAIL",
    flex: 1.5,
    minWidth: 220,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "location",
    headerName: "LOCATION",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "active_status",
    headerName: "ACTIVE STATUS",
    flex: 0.9,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    sortable: false,
    filterable: false,

    renderCell: (params) => (
      // <div
      //   className="form-check form-switch"
      //   style={{
      //     display: "flex",
      //     alignItems: "center",
      //     justifyContent: "center",
      //     width: "100%",
      //     height: "100%",
      //     margin: 0,
      //   }}
      // >
      //   <input
      //     type="checkbox"
      //     className="form-check-input"
      //     id={`toggle-${params.id}`}
      //     checked={params.row.active_status}
      //     // onChange={() =>
      //     //   handleTogglerModalOpen("wholesaler", params.row)
      //     // }
      //   />
      // </div>
      <span
        style={{
          fontWeight: 500,
          color: params.row.active_status ? "#198754" : "#dc3545",
        }}
      >
        {params.row.active_status ? "Active" : "Inactive"}
      </span>
    ),
  },
];
const retailer_columns = [
  {
    field: "retailer_id",
    headerName: "RETAILER ID",
    flex: 0.8,
    minWidth: 140,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "business_name",
    headerName: "BUSINESS NAME",
    flex: 1.3,
    minWidth: 200,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "email",
    headerName: "EMAIL",
    flex: 1.5,
    minWidth: 220,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "location",
    headerName: "LOCATION",
    flex: 1,
    minWidth: 180,
    align: "center",
    headerAlign: "center",
  },
  {
    field: "active_status",
    headerName: "ACTIVE STATUS",
    flex: 0.9,
    minWidth: 150,
    align: "center",
    headerAlign: "center",
    sortable: false,
    filterable: false,

    renderCell: (params) => (
      // <div
      //   className="form-check form-switch"
      //   style={{
      //     display: "flex",
      //     alignItems: "center",
      //     justifyContent: "center",
      //     width: "100%",
      //     height: "100%",
      //     margin: 0,
      //   }}
      // >
      //   <input
      //     type="checkbox"
      //     className="form-check-input"
      //     id={`toggle-${params.id}`}
      //     checked={params.row.active_status}
      //     // onChange={() =>
      //     //   handleTogglerModalOpen("wholesaler", params.row)
      //     // }
      //   />
      // </div>
      <span
        style={{
          fontWeight: 500,
          color: params.row.active_status ? "#198754" : "#dc3545",
        }}
      >
        {params.row.active_status ? "Active" : "Inactive"}
      </span>
    ),
  },
];

// ===== Load Google Maps =====
const loadGoogleMapsScript = (callback) => {
  if (window.google && window.google.maps) {
    callback();
  } else {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyBNZ6QvXiknFj5OmY4hnUxPoWDnmtQiLko&libraries=places,geometry`;
    script.async = true;
    script.onload = callback;
    document.body.appendChild(script);
  }
};

const validationSchema = object().shape({
  vehicle_type: string().trim().required("vehicle type is required"),
  city: string().required("city is required"),
  radius_from_retailer: string().required("radius from retailer is required"),
  charge_per_km: string().required("charge per km  is required"),
  minimum_charge: string().required("minimum charge km  is required"),
});

export const EditRyderZone = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const [activeEdit, setactiveEdit] = useState("wholesaler");

  // ===== Map / City State =====
  const [mapModalOpen, setMapModalOpen] = useState(false);
  const [selectedCityLatLng, setSelectedCityLatLng] = useState(null);
  const mapRef = useRef(null);
  const circleRef = useRef(null);
  const cityTypingTimeout = useRef(null);

  const autocompleteRef = useRef(null);

  const formik = useFormik({
    initialValues: {
      vehicle_type: "",
      city: "",
      radius_from_retailer: "",
      charge_per_km: "",
      gomak_commision: "",
      ryder_gst: "",
      gomak_gst: "",
      minimum_charge: "",
      snap_order_commision: "",
      adhoc_order_commision: "",
      is_active: false,
      status: true,
      // is_enabled: false,
      gomakcash_amount: "",
      gomakcash_active: false,
      gomakcash_start_date: null,
      gomakcash_end_date: null,
    },
    validationSchema,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        const existingGomakAmount = Number(values.gomakcash_amount || 0);

        // If existing amount is 0,
        // the new input amount will be saved through PUT.
        const finalGomakCashAmount =
          existingGomakAmount === 0
            ? Number(gomakAmount || 0)
            : existingGomakAmount;

        const payload = {
          city: values.city.trim(),
          vehicle_type: values.vehicle_type,
          radius_from_retailer: values.radius_from_retailer,
          charge_per_km: values.charge_per_km,
          gomak_commision: values.gomak_commision,
          ryder_gst: values.ryder_gst,
          gomak_gst: values.gomak_gst,
          minimum_charge: values.minimum_charge,
          snap_order_commision: values.snap_order_commision
            ? values.snap_order_commision
            : 0,
          adhoc_order_commision:
            values.adhoc_order_commision === "" ||
            values.adhoc_order_commision === null
              ? 0
              : Number(values.adhoc_order_commision),
          is_active: values.is_active,
          status: true,
          // Important:
          // Existing amount 0 -> use entered gomakAmount
          // Existing amount > 0 -> keep existing amount
          gomakcash_amount: finalGomakCashAmount,
          // is_enabled: values.is_enabled,
          // gomakcash_amount:
          //   values.gomakcash_amount === null
          //     ? 0
          //     : Number(values.gomakcash_amount), // not editable
          gomakcash_active: values.gomakcash_active,
          gomakcash_start_date: values.gomakcash_start_date,
          gomakcash_end_date: values.gomakcash_end_date,
        };

        const response = await axiosInstance.put(
          `/admin/ryder-zones/${id}/`,
          payload,
        );

        if (response.data.status === "success") {
          // Gomak Cash is active
          if (values.is_active === true && values.gomakcash_active === true) {
            const gomakSuccess = await handleGomakCashUserlist();

            if (gomakSuccess) {
              navigate("/ryder-zone");
            }
          } else {
            toast.success("RyderZone updated successfully!");
            // Gomak Cash is inactive
            navigate("/ryder-zone");
          }
          // setTimeout(() => navigate("/ryder-zone"), 1500);
        } else {
          toast.error(response.data.message || "Failed to update RyderZone.");
        }
      } catch (err) {
        console.error("❌ Error updating RyderZone:", err);
        toast.error("Something went wrong. Please try again.");
      } finally {
        setLoading(false);
      }
    },
  });

  const handleCancel = () => {
    navigate("/ryder-zone");
  };

  useEffect(() => {
    const fetchAdminDetails = async () => {
      try {
        const res = await axiosInstance.get(`/admin/ryder-zones/${id}`);
        if (res.data.status === "success" && res.data.data) {
          setRyderZone(res.data.data.city);
          formik.setValues({
            city: res.data.data.city || "",
            vehicle_type: res.data.data.vehicle_type || "",
            radius_from_retailer: res.data.data.radius_from_retailer || "",
            charge_per_km: res.data.data.charge_per_km || "",
            gomak_commision: res.data.data.gomak_commision || "",
            ryder_gst: res.data.data.ryder_gst || "",
            gomak_gst: res.data.data.gomak_gst || "",
            minimum_charge: res.data.data.minimum_charge || "",
            snap_order_commision: res.data.data.snap_order_commision || 0,
            adhoc_order_commision: res.data.data.adhoc_order_commision || 0,
            status: res.data.data.status ?? true,
            is_active: res.data.data.is_active ?? false,
            // is_enabled: res.data.data.is_enabled,

            gomakcash_active: res.data.data.gomakcash_active,
            gomakcash_amount: res.data.data.gomakcash_amount || 0,
            gomakcash_start_date: res.data.data.gomakcash_start_date,
            gomakcash_end_date: res.data.data.gomakcash_end_date,
          });
        } else {
          toast.error("Failed to load RyderZone details.");
        }
      } catch (err) {
        console.error("Error fetching RyderZone data:", err);
        toast.error("Something went wrong while loading RyderZone data.");
      }
    };

    fetchAdminDetails();
  }, [id]);

  const VEHICLE_CHOICES = [
    { value: "2_wheeler", label: "2 Wheeler" },
    { value: "3_wheeler", label: "3 Wheeler" },
  ];

  // City input typing (just store value now, no map open)
  const handleCityChange = (event) => {
    formik.handleChange(event);

    if (cityTypingTimeout.current) {
      clearTimeout(cityTypingTimeout.current);
    }

    // No map logic here — only place_changed will handle that
    cityTypingTimeout.current = setTimeout(() => {
      // could add validations or API check here if needed later
    }, 500);
  };

  // Initialize map when modal opens
  useEffect(() => {
    if (mapModalOpen && selectedCityLatLng) {
      const map = new window.google.maps.Map(mapRef.current, {
        center: selectedCityLatLng,
        zoom: 12,
      });

      const initialRadiusMeters = formik.values.radius_from_retailer * 1000;

      circleRef.current = new window.google.maps.Circle({
        strokeColor: "#4285F4",
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: "#4285F4",
        fillOpacity: 0.15,
        map,
        center: selectedCityLatLng,
        radius: initialRadiusMeters,
        editable: true,
      });

      window.google.maps.event.addListener(
        circleRef.current,
        "radius_changed",
        () => {
          const kmRadius = circleRef.current.getRadius() / 1000;
          formik.setFieldValue("radius_from_retailer", kmRadius.toFixed(2));
        },
      );

      window.google.maps.event.addListener(
        circleRef.current,
        "center_changed",
        () => {
          const center = circleRef.current.getCenter();
          formik.setFieldValue("latitude", center.lat());
          formik.setFieldValue("longitude", center.lng());
        },
      );
    }
  }, [mapModalOpen, selectedCityLatLng]);

  useEffect(() => {
    return () => {
      if (cityTypingTimeout.current) {
        clearTimeout(cityTypingTimeout.current);
      }
    };
  }, []);

  useEffect(() => {
    loadGoogleMapsScript(() => {
      if (autocompleteRef.current && !autocompleteRef.current.autocomplete) {
        const autocomplete = new window.google.maps.places.Autocomplete(
          autocompleteRef.current,
          {
            types: ["(cities)"], // Only cities
          },
        );

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace();
          if (place && place.geometry && place.geometry.location) {
            const cityName = place.name;
            const location = place.geometry.location;

            formik.setFieldValue("city", cityName);
            formik.setFieldValue("latitude", location.lat());
            formik.setFieldValue("longitude", location.lng());

            if (place.geometry.viewport) {
              const ne = place.geometry.viewport.getNorthEast();
              const center = location;
              const radiusMeters =
                window.google.maps.geometry.spherical.computeDistanceBetween(
                  center,
                  ne,
                );
              formik.setFieldValue(
                "radius_from_retailer",
                (radiusMeters / 1000).toFixed(2),
              );
            }

            setSelectedCityLatLng(location);
            setMapModalOpen(true); // ✅ now opens only after actual selection
          }
        });

        autocompleteRef.current.autocomplete = autocomplete;
      }
    });
  }, []);

  // gomak cash amount api's
  const [ryderZone, setRyderZone] = useState("");
  const [ryderzoneUsersList, setRyderzoneUsersList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  async function FetchRyderzoneUsersList() {
    try {
      setLoading(true);
      let config;

      if (activeEdit === "wholesaler") {
        config = {
          params: {
            user_type: "wholesaler",
            ryder_zone: ryderZone,
            search: searchQuery,
          },
        };
      } else {
        config = {
          params: {
            user_type: "retailer",
            ryder_zone: ryderZone,
            search: searchQuery,
          },
        };
      }
      const response = await axiosInstance.get(
        "/admin/ryderzone-userlist/",
        config,
      );
      if (response.data.status === "success" || response.status === 200) {
        setRyderzoneUsersList(response.data?.data?.results || []);
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message ||
          "Failed to fetch ryder zone users list",
      );
      console.log(
        error?.response?.data?.message ||
          "Failed to fetch ryder zone users list",
      );
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (ryderZone) {
      FetchRyderzoneUsersList();
    }
  }, [activeEdit, ryderZone, searchQuery]);

  useEffect(() => {
    setSelectedUserIds([]);
  }, [activeEdit]);

  const [selectedUserIds, setSelectedUserIds] = useState([]);
  const [gomakAmount, setGomakAmount] = useState("");
  const [applyType, setApplyType] = useState("all");
  const [gomakCashError, setGomakCashError] = useState("");

  async function handleGomakCashUserlist() {
    try {
      // Required validation
      const existingAmount = Number(formik.values.gomakcash_amount || 0);
      const enteredAmount = gomakAmount === "" ? null : Number(gomakAmount);

      // Existing Gomak Cash amount is 0
      // So new amount is mandatory
      if (
        formik.values.gomakcash_active &&
        existingAmount === 0 &&
        gomakAmount === ""
      ) {
        setGomakCashError("Gomak cash amount is required");
        return false;
      }

      // If user entered an amount, it cannot be negative
      if (enteredAmount !== null && enteredAmount < 0) {
        setGomakCashError("Gomak cash amount cannot be negative");
        return false;
      }
      if (applyType === "individual" && selectedUserIds.length === 0) {
        toast.error(
          `Please select at least one ${
            activeEdit === "wholesaler" ? "wholesaler" : "retailer"
          }.`,
        );
        return false;
      }

      setGomakCashError("");

      setLoading(true);
      const payload = {
        apply_to: applyType,
        user_type: activeEdit,
        wholesalers: activeEdit === "wholesaler" ? selectedUserIds : [],
        retailers: activeEdit === "retailer" ? selectedUserIds : [],
        // first time amount means if gomakcash_amount is 0 then send to that key or else send to amount key
        amount:
          Number(gomakAmount) === 0
            ? Number(formik.values.gomakcash_amount || 0)
            : Number(gomakAmount),
        ryder_zone: ryderZone,
        // first time ryder zone , second time adding admin
        transaction_source: Number(gomakAmount) > 0 ? "admin" : "ryder_zone",
      };
      const response = await axiosInstance.post(
        "/admin/gomakcash-addition-user-wallet/",
        payload,
      );
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data?.message);
        return true;
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "Failed to submit users list",
      );
      console.log(
        error?.response?.data?.message || "Failed to submit users list",
      );
      return false;
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      <div className="addAdmin-container">
        <div className="addAdmin-subcontainer d-flex justify-content-between">
          <div className="d-flex align-items-center gap-2">
            <FaArrowLeftLong
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/ryder-zone")}
            />
            <div className="add-title">Edit Ryder Zone</div>
          </div>
          <div className="d-flex">
            <span
              style={{
                color: "#4A5565",
                fontSize: "14px",
                paddingRight: "10px",
              }}
            >
              {/* Enable / Disable */}
              Active / Inactive
            </span>
            <div className="form-check form-switch">
              <input
                type="checkbox"
                className="form-check-input"
                id="toggleSwitch"
                // name="is_enabled"
                name="is_active"
                // checked={formik.values.is_enabled === true}
                checked={formik.values.is_active === true}
                onChange={(e) =>
                  formik.setFieldValue("is_active", e.target.checked)
                }
              />

              <label className="form-check-label" htmlFor="toggleSwitch" />
            </div>
          </div>
        </div>

        <form onSubmit={formik.handleSubmit}>
          <div className="addAdmin-content">
            <div className="addAdmin-contentLeft">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Vehicle Type
                </label>
                <div>
                  <select
                    name="vehicle_type"
                    value={formik.values.vehicle_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  >
                    <option value="">Select Vehicle Type</option>
                    {VEHICLE_CHOICES.map((vehicle) => (
                      <option key={vehicle.value} value={vehicle.value}>
                        {vehicle.label}
                      </option>
                    ))}
                  </select>

                  {formik.touched.vehicle_type &&
                    formik.errors.vehicle_type && (
                      <div className="text-danger">
                        {formik.errors.vehicle_type}
                      </div>
                    )}
                </div>
              </div>
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Radius From Retailer
                </label>
                <div>
                  <input
                    type="number"
                    name="radius_from_retailer"
                    min="0"
                    step="0.01" // allows decimal values like 29.38
                    placeholder="Enter Your radius from retailer"
                    value={formik.values.radius_from_retailer}
                    onChange={(e) => {
                      // Ensure numeric value is stored
                      formik.setFieldValue(
                        "radius_from_retailer",
                        e.target.value === "" ? "" : parseFloat(e.target.value),
                      );
                    }}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.radius_from_retailer &&
                    formik.errors.radius_from_retailer && (
                      <div className="text-danger">
                        {formik.errors.radius_from_retailer}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="addAdmin-contentRight">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> City
                </label>
                <div>
                  <input
                    type="text"
                    name="city"
                    placeholder="Enter Your city"
                    ref={autocompleteRef}
                    value={formik.values.city}
                    onChange={handleCityChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.city && formik.errors.city && (
                    <div className="text-danger">{formik.errors.city}</div>
                  )}
                </div>
              </div>
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Charge Per KM
                </label>
                <div>
                  <input
                    type="number"
                    name="charge_per_km"
                    min="0"
                    step="0.01"
                    placeholder="Enter Your charge per km "
                    value={formik.values.charge_per_km}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.charge_per_km &&
                    formik.errors.charge_per_km && (
                      <div className="text-danger">
                        {formik.errors.charge_per_km}
                      </div>
                    )}
                </div>
              </div>
            </div>

            <div className="addAdmin-contentLeft">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Gomak Commision %
                </label>
                <div>
                  <input
                    type="number"
                    name="gomak_commision"
                    min="0"
                    placeholder="Enter Your gomak commision"
                    value={formik.values.gomak_commision}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.gomak_commision &&
                    formik.errors.gomak_commision && (
                      <div className="text-danger">
                        {formik.errors.gomak_commision}
                      </div>
                    )}
                </div>
              </div>
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Ryder GST %
                </label>
                <div>
                  <input
                    type="number"
                    name="ryder_gst"
                    min="0"
                    placeholder="Enter Your ryder gst"
                    value={formik.values.ryder_gst}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.ryder_gst && formik.errors.ryder_gst && (
                    <div className="text-danger">{formik.errors.ryder_gst}</div>
                  )}
                </div>
              </div>

              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Minimum Charge
                </label>
                <div>
                  <input
                    type="number"
                    name="minimum_charge"
                    min="0"
                    placeholder="Enter Your minimum charge"
                    value={formik.values.minimum_charge}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.minimum_charge &&
                    formik.errors.minimum_charge && (
                      <div className="text-danger">
                        {formik.errors.minimum_charge}
                      </div>
                    )}
                </div>
              </div>
            </div>
            <div className="addAdmin-contentRight">
              <div className="addAdmin-field">
                <label>
                  <span className="text-danger">*</span> Gomak GST %
                </label>
                <div>
                  <input
                    type="text"
                    name="gomak_gst"
                    placeholder="Enter gomak gst"
                    value={formik.values.gomak_gst}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.gomak_gst && formik.errors.gomak_gst && (
                    <div className="text-danger">{formik.errors.gomak_gst}</div>
                  )}
                </div>
              </div>

              <div className="addAdmin-field">
                <label>Snap Order Commision</label>
                <div>
                  <input
                    type="number"
                    name="snap_order_commision"
                    min="0"
                    placeholder="Enter Your snap order commision"
                    value={formik.values.snap_order_commision}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
              <div className="addAdmin-field">
                <label>Adhoc Order Commision</label>
                <div>
                  <input
                    type="number"
                    name="adhoc_order_commision"
                    min="0"
                    placeholder="Enter Your adhoc order commision"
                    value={formik.values.adhoc_order_commision}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                </div>
              </div>
            </div>
            {/* <div className="addAdmin-contentLeft">
              <div className="addAdmin-field">
                <label>Gomak Cash Amount</label>
                <div>
                  <input
                    type="number"
                    name="gomakcash_amount"
                    min="0"
                    placeholder="Enter Your gomak cash amount"
                    value={formik.values.gomakcash_amount}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    readOnly
                  />
                  {formik.touched.gomakcash_amount &&
                    formik.errors.gomakcash_amount && (
                      <div className="text-danger">
                        {formik.errors.gomakcash_amount}
                      </div>
                    )}
                </div>
              </div>
            </div> */}
          </div>

          {/* show this entire block only when is_active is true  */}
           {formik.values.is_active && (
            <>
              {/* gomak cash toggler   */}
              <div className="ryderZone-Gomak-box">
                <div className="d-block">
                  <h5>Gomak Cash</h5>
                  <p>
                    Show or hide the Cash Deposit offer for wholesalers and
                    retailers in this zone
                  </p>
                </div>
                <div className="form-check form-switch">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id="toggleSwitch"
                    name="gomakcash_active"
                    checked={formik.values.gomakcash_active === true}
                    onChange={(e) =>
                      formik.setFieldValue("gomakcash_active", e.target.checked)
                    }
                  />

                  <label className="form-check-label" htmlFor="toggleSwitch" />
                </div>
              </div>
              {formik.values.gomakcash_active && (
                <>
                  <div className="applyFreeText">
                    <h4>Apply Free Gomak Cash Amount</h4>
                    <p>Provide free amount in Gomak Cash</p>
                  </div>
                  {/* tabs menus  */}
                  <div className="wholesalerMenu mb-3">
                    <div
                      onClick={() => {
                        setactiveEdit("wholesaler");
                      }}
                      className={`edit-menu ${
                        activeEdit === "wholesaler" ? "activeEdit" : ""
                      }`}
                    >
                      Wholesalers
                    </div>
                    <div
                      onClick={() => {
                        setactiveEdit("retailer");
                      }}
                      className={`edit-menu ${
                        activeEdit === "retailer" ? "activeEdit" : ""
                      }`}
                    >
                      Retailers
                    </div>
                  </div>

                  <div>
                    <div className="ryder-amountContainer">
                      <div className="amount-form-group">
                        <label className="amount-form-label">
                          Apply To{" "}
                          {formik.values.gomakcash_amount === 0 ? (
                            <span className="text-danger">*</span>
                          ) : (
                            ""
                          )}
                        </label>

                        <div className="apply-to-options">
                          <label className="radio-option">
                            <input
                              type="radio"
                              name="applyTo"
                              value="all"
                              checked={applyType === "all"}
                              onChange={(e) => setApplyType(e.target.value)}
                            />
                            <span>All</span>
                          </label>

                          <label className="radio-option">
                            <input
                              type="radio"
                              name="applyTo"
                              value="individual"
                              checked={applyType === "individual"}
                              onChange={(e) => setApplyType(e.target.value)}
                            />
                            <span>Individual</span>
                          </label>
                        </div>
                      </div>

                      <div className="amount-form-group">
                        {formik.values.gomakcash_amount > 0 ? (
                          <label className="amount-form-label">
                            Default Gomak Cash Amount :{" "}
                            <b>{formik.values.gomakcash_amount}</b>/-
                          </label>
                        ) : (
                          ""
                        )}
                        <label className="amount-form-label">
                          Gomak Cash Amount (₹){" "}
                          {formik.values.gomakcash_amount === 0 ? (
                            <span className="text-danger">*</span>
                          ) : (
                            ""
                          )}
                        </label>

                        <div className="amount-input-wrapper">
                          <input
                            type="number"
                            // min={0}
                            className="amount-input"
                            placeholder="Enter Amount"
                            value={gomakAmount}
                            onChange={(e) => {
                              const value = e.target.value;
                              setGomakAmount(value);

                              // Clear error when enters a valid value
                              if (value !== "" && Number(value) >= 0) {
                                setGomakCashError("");
                              }
                            }}
                          />
                        </div>
                        <div style={{ color: "red", fontSize: "12px" }}>
                          {gomakCashError}
                        </div>
                      </div>
                    </div>
                    <div className="ryder-zone-noteBox">
                      <span className="me-1">
                        <IoIosInformationCircleOutline />
                      </span>
                      {` The above amount will be added to Ride Wallet of all ${activeEdit === "wholesaler" ? "wholesalers" : "retailers"}
              in this zone.`}
                    </div>
                    {applyType === "individual" && (
                      <>
                        <div className="ryderzone-search-container">
                          <div className="ryderzone-search-wrapper">
                            <div className="ryderzone-search">
                              <GoSearch className="ryderzone-search-icon" />

                              <input
                                type="text"
                                placeholder="Search"
                                value={searchQuery}
                                onChange={(e) => setSearchQuery(e.target.value)}
                              />
                            </div>
                          </div>

                          <div style={{ color: "#6A7282", fontSize: "14px" }}>
                            Selected :
                            {selectedUserIds.length > 0
                              ? selectedUserIds.length
                              : "0"}
                          </div>
                        </div>

                        {/* table  */}
                        {activeEdit === "wholesaler" && (
                          <Box
                            sx={{
                              width: "100%",
                              backgroundColor: "#fff",
                              borderRadius: "12px",
                              overflow: "hidden",
                              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.06)",
                              marginTop: "30px",
                              marginBottom: "30px",
                            }}
                          >
                            <DataGrid
                              rows={ryderzoneUsersList}
                              columns={wholesaler_columns}
                              // getRowId={(row) => row.wholesaler_id} by default takes id
                              disableColumnMenu
                              // disableColumnResize // table header drag option
                              disableColumnSorting
                              disableRowSelectionOnClick
                              checkboxSelection
                              initialState={{
                                pagination: {
                                  paginationModel: {
                                    pageSize: 5,
                                  },
                                },
                              }}
                              pageSizeOptions={[5, 10, 25]}
                              rowHeight={58}
                              onRowSelectionModelChange={(newSelection) => {
                                setSelectedUserIds(newSelection); // by default store id
                              }}
                              sx={{
                                border: "none",

                                // Header
                                "& .MuiDataGrid-columnHeaders": {
                                  backgroundColor: "#f8f9fa",
                                  borderBottom: "1px solid #e5e7eb",
                                },

                                // Center header text
                                "& .MuiDataGrid-columnHeader": {
                                  justifyContent: "center",
                                },

                                "& .MuiDataGrid-columnHeaderTitle": {
                                  fontWeight: 600,
                                  fontSize: "13px",
                                  color: "#374151",
                                },

                                // Center cell content
                                "& .MuiDataGrid-cell": {
                                  justifyContent: "center",
                                  fontSize: "14px",
                                  color: "#374151",
                                },

                                // Rows
                                "& .MuiDataGrid-row": {
                                  borderBottom: "1px solid #f1f1f1",
                                },

                                "& .MuiDataGrid-row:hover": {
                                  backgroundColor: "#f8fafc",
                                },

                                // Footer
                                "& .MuiDataGrid-footerContainer": {
                                  borderTop: "1px solid #e5e7eb",
                                  minHeight: "52px",
                                },

                                // Remove focus outline
                                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus":
                                  {
                                    outline: "none",
                                  },
                              }}
                            />
                          </Box>
                        )}

                        {activeEdit === "retailer" && (
                          <Box
                            sx={{
                              width: "100%",
                              backgroundColor: "#fff",
                              borderRadius: "12px",
                              overflow: "hidden",
                              boxShadow: "0 2px 10px rgba(0, 0, 0, 0.06)",
                              marginTop: "30px",
                              marginBottom: "30px",
                            }}
                          >
                            <DataGrid
                              rows={ryderzoneUsersList}
                              columns={retailer_columns}
                              // getRowId={(row) => row.retailer_id} by default use id
                              disableColumnMenu
                              // disableColumnResize // table header drag option
                              disableColumnSorting
                              disableRowSelectionOnClick
                              checkboxSelection
                              initialState={{
                                pagination: {
                                  paginationModel: {
                                    pageSize: 5,
                                  },
                                },
                              }}
                              pageSizeOptions={[5, 10, 25]}
                              rowHeight={58}
                              onRowSelectionModelChange={(newSelection) => {
                                setSelectedUserIds(newSelection); // by default store id
                              }}
                              sx={{
                                border: "none",

                                // Header
                                "& .MuiDataGrid-columnHeaders": {
                                  backgroundColor: "#f8f9fa",
                                  borderBottom: "1px solid #e5e7eb",
                                },

                                // Center header text
                                "& .MuiDataGrid-columnHeader": {
                                  justifyContent: "center",
                                },

                                "& .MuiDataGrid-columnHeaderTitle": {
                                  fontWeight: 600,
                                  fontSize: "13px",
                                  color: "#374151",
                                },

                                // Center cell content
                                "& .MuiDataGrid-cell": {
                                  justifyContent: "center",
                                  fontSize: "14px",
                                  color: "#374151",
                                },

                                // Rows
                                "& .MuiDataGrid-row": {
                                  borderBottom: "1px solid #f1f1f1",
                                },

                                "& .MuiDataGrid-row:hover": {
                                  backgroundColor: "#f8fafc",
                                },

                                // Footer
                                "& .MuiDataGrid-footerContainer": {
                                  borderTop: "1px solid #e5e7eb",
                                  minHeight: "52px",
                                },

                                // Remove focus outline
                                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-columnHeader:focus":
                                  {
                                    outline: "none",
                                  },
                              }}
                            />
                          </Box>
                        )}
                      </>
                    )}
                  </div>
                </>
              )}
            </>
          )}

          <div className="addbtnContainer">
            <div>
              <button
                type="button"
                className="admin-btnCancel"
                onClick={handleCancel}
                disabled={loading}
              >
                Cancel
              </button>
            </div>
            <div>
              <button className="add-btnSave">Update</button>
            </div>
          </div>
        </form>
      </div>

      {/* ===== Map Modal ===== */}
      <Modal
        show={mapModalOpen}
        onHide={() => setMapModalOpen(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Select City Radius</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div ref={mapRef} style={{ width: "100%", height: "400px" }}></div>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-primary"
            onClick={() => setMapModalOpen(false)}
          >
            OK
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
